import { Link } from 'react-router';
import { useT } from '../i18n';

/** "Drive | Sensors" switch in the robot page header (design: Robot views). */
export function RobotTabs({ serial, active }: { serial: string; active: 'drive' | 'sensors' }) {
  const t = useT();
  const base = `/robots/${encodeURIComponent(serial)}`;
  return (
    <nav aria-label={t('sens.robotViews')} className="seg sm robot-tabs">
      <Link to={base} aria-current={active === 'drive' ? 'page' : undefined} aria-selected={active === 'drive'} className="seg-link">
        {t('sens.tabDrive')}
      </Link>
      <Link to={`${base}/sensors`} aria-current={active === 'sensors' ? 'page' : undefined} aria-selected={active === 'sensors'} className="seg-link">
        {t('sens.tabSensors')}
      </Link>
    </nav>
  );
}
